export const GALLERY_PAGE_SIZE = 12; // Divisible by 1, 2, 3, 4

export const MEDIA_ASPECT = 16 / 9;
